import React, { useState, useEffect } from "react";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import localization from "assets/localization/localization";
import Images from "assets/images/imageData";
import { Button } from "react-bootstrap";
import DatePicker from "components/sales/datePicker/datePicker";

const PlanListFilter = ({
  showFilter = false,
  filterToggle,
  internalStatus,
  applyFilter,
  documentUploadUrlPublic,
  documentUrlDataPublic
}) => {
  const filterInputs = {
    siteNumber:'',
    agenda: '',
    userEmail: '',
    planDate:'',
    message: ''
  };
  //console.log('FILTER::L2_REPLY');
  const [filterFieldsData, setFilterFieldsData] = useState(filterInputs);
  const [listStatus, setListStatus] = useState("");
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        applyFilter(filterFieldsData);
        filterFieldsData && localStorage.setItem("applyFilter", JSON.stringify(filterFieldsData));
        listStatus && localStorage.setItem("statusFilter", JSON.stringify(listStatus));
      }}
    >
    <div className={showFilter ? "show-filter" : ""}>
      {showFilter && (
        <div className="filter-wrapper">
          <div className="filter-heading">
            <h4>Filter List</h4>
            <Button onClick={filterToggle} className="close">
              <i className="close"></i>
            </Button>
          </div>
          {console.log(filterFieldsData)}
          <div className="filter-body scrollbar-styling">
            <div className="col-md-12">
            <ConstantInput
                label={"Site Number"}
                value={filterFieldsData?.siteNumber}
                type="text"
                handleChange={(val) => {
                    setFilterFieldsData({ ...filterFieldsData, siteNumber: val });
                }}
            />
            </div>
            <div className="col-md-12">
            <ConstantInput
                label={"Agenda"}
                value={filterFieldsData?.agenda}
                type="text"
                handleChange={(val) => {
                    setFilterFieldsData({ ...filterFieldsData, agenda: val });
                }}
            />
            </div>
            <div className="col-md-12">
            <ConstantInput
                label={"User Email"}
                value={filterFieldsData?.userEmail}
                type="text"
                handleChange={(val) => {
                    setFilterFieldsData({ ...filterFieldsData, userEmail: val });
                }}
            />
            </div>
            <div className="col-md-12">
            <ConstantInput
                label={"Message"}
                value={filterFieldsData?.message}
                type="text"
                handleChange={(val) => {
                    setFilterFieldsData({ ...filterFieldsData, message: val });
                }}
            />
            </div>
            <div className="col-md-12">
            <DatePicker
                required={false}
                label='Plan Date'
                value={filterFieldsData?.planDate}
                handleChange={(value) => setFilterFieldsData({ ...filterFieldsData, planDate: value.split("-").reverse().join("-") })}
            />
            </div>
        
             <hr/>

              <div className="btn-wrapper">
                <button disabled={false} type="submit" className="btn btn-primary">
                    {localization.applyFilter}
                    <img src={Images?.ArrowRight} alt="" />
                </button>
                <br />
                <br />
                <button
                    onClick={() => {
                        localStorage.setItem('planListingDataFilter', JSON.stringify(filterInputs));
                        applyFilter(filterInputs);
                        localStorage.setItem('planListingDataFilter', null);
                    }}
                    type="button"
                    className="btn btn-primary"
                >
                    {localization.removeFilter}
                </button>
            </div>
          </div>
        </div>
      )}
    </div>
    </form>
  );
};

export default PlanListFilter;
